/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { HealthStatus } from "../../models/health-status";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetSubscriptionInstanceHealthStatus$Params {
  subscription_id: string;
  subscription_instance_id: string;
}

export function getSubscriptionInstanceHealthStatus(
  http: HttpClient,
  rootUrl: string,
  params: GetSubscriptionInstanceHealthStatus$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<HealthStatus>> {
  const rb = new RequestBuilder(rootUrl, getSubscriptionInstanceHealthStatus.PATH, "get");
  if (params) {
    rb.path("subscription_id", params.subscription_id, {});
    rb.path("subscription_instance_id", params.subscription_instance_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json; charset&#x3D;utf-8", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HealthStatus>;
    }),
  );
}

getSubscriptionInstanceHealthStatus.PATH = "/dashboard/health/{subscription_id}/{subscription_instance_id}";
